import { useMemo } from 'react';

import { getMapStyles, type MapMode } from '@utils/googleMapOptions';
import { setMapSpotlight, setMapMode, useMapPreferencesStore } from './mapPreferences';

/** Read + write the global map mode/spotlight preferences. */
export const useMapPreferences = () => {
  const mode = useMapPreferencesStore(state => state.mode);
  const spotlight = useMapPreferencesStore(state => state.spotlight);

  const mapStyles = useMemo(() => getMapStyles(mode, spotlight), [mode, spotlight]);

  return {
    mode,
    spotlight,
    mapStyles,
    setMode: setMapMode,
    setSpotlight: setMapSpotlight,
  };
};

export type { MapMode };
